<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-default">
            </div>
            <div class="container shape-container pt-md">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-7">
                        <h2 class="text-white display-1">Sacola de <span>Títulos</span></h2>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
            	<div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Ações da Sacola de Títulos" v-if="Object.keys(groupedSacolaTitulos).length">
                  <div class="btn-group my-2" role="group" aria-label="First group">
                    <b-form-checkbox v-model="allSelected" @change="toggleAll" name="check-button" button button-variant="secondary" size="sm">
                      {{ allSelected ? 'Desmarcar Todas' : 'Marcas Todas' }}
                    </b-form-checkbox>
                  </div>
                  <div class="btn-group my-2" role="group" aria-label="First group">
                    <base-button type="primary" size="sm" class="d-inline-block ml-2" :disabled="!selected.length" @click="removeMedia(selected)">
                      Remover Selecionadas
                    </base-button>
                  </div>
                  <div class="btn-group my-2" role="group" aria-label="First group">
                    <base-button type="success" size="sm" class="d-inline-block float-right" @click="checkCartItemToCheckout()">
                      Solicitar Mídias
                    </base-button>
                  </div>
                </div>
              <div v-if="Object.keys(groupedSacolaTitulos).length">
              <div class="table-responsive my-4" v-for="(titulo,nome) in groupedSacolaTitulos" :key="titulo.titulo_id">
                <table class="table cart-table">
                  <thead>
                    <tr v-if="titulo.length">
                      <th scope="row" colspan="7" class="titleName">{{nome}}</th>
                    </tr>
                    <tr>
                      <th scope="col" class="format">Qualidade</th>
                      <th scope="col">Fonte</th>
                      <th scope="col" class="text-center">Faixas de Áudio</th>
                      <th scope="col" class="text-center">Dublagem Disponível</th>
                      <th scope="col" class="text-center">Legendas</th>
                      <th scope="col" v-if="isSeriado(titulo)">Temporada</th>
                      <th scope="col" class="text-center">Discos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="midia in titulo">
                      <tr :key="midia.id" :class="[midia.preco ? 'gold' : '']">
                        <th scope="row">
                          <b-form-checkbox
                            v-model="selected"
                            :value="midia"
                            name="midia.id"
                            inline
                          >
                          <img width="20" height="20" :src="[midia.formato ? 'img/mediaformat/'+midia.formato+'.svg' : 'numtem']">
                          {{midia.formato}}
                          </b-form-checkbox>
                        </th>
                        <td><span class="badge badge-info">{{midia.origem}}</span></td>
                        <td class="text-center"><span v-if="midia.audio" class="badge badge-success">{{midia.audio}}</span></td>
                        <td class="text-center"><p v-if="midia.estudios_dublagem.length" v-html="midia.estudios_dublagem.join(' + ')"></p><p v-if="midia.trecho" class="trecho">({{ midia.observacoes }})</p></td>
                        <td class="text-center"><p v-if="midia.legendas">{{midia.legendas}}</p></td>
                        <td v-if="isSeriado(titulo)"><p v-if="midia.temporada">{{midia.temporada}}&#170; temporada</p></td>
                        <td class="text-center"><p>{{ !midia.discos ? '1' : midia.discos }}</p></td>
                      </tr>
                      <tr v-if="midia.episodios && midia.episodios.length > 0" :key="`${midia.id}-episodio-list`" :class="[midia.preco ? 'gold' : '']">
                        <td colspan="8">
                          <div class="episodios">
                            <strong>Episódios presentes na mídia:</strong>
                            <p v-for="episodio in midia.episodios" :key="episodio.id" :title="episodioFormat(episodio)">
                              {{episodioFormat(episodio)}}
                            </p>
                          </div>
                        </td>
                      </tr>
                      </template>
                  </tbody>
                </table>
              </div>
              </div>
                <div class="btn-toolbar justify-content-between" role="toolbar" aria-label="Ações da Sacola de Títulos" v-if="Object.keys(groupedSacolaTitulos).length">
                  <div class="btn-group my-2" role="group" aria-label="First group">
                    <b-form-checkbox v-model="allSelected" @change="toggleAll" name="check-button" button button-variant="secondary" size="sm">
                      {{ allSelected ? 'Desmarcar Todas' : 'Marcas Todas' }}
                    </b-form-checkbox>
                  </div>
                  <div class="btn-group my-2" role="group" aria-label="First group">
                    <base-button type="primary" size="sm" class="d-inline-block ml-2" :disabled="!selected.length" @click="removeMedia(selected)">
                      Remover Selecionadas
                    </base-button>
                  </div>
                  <div class="btn-group my-2" role="group" aria-label="First group">
                    <base-button type="success" size="sm" class="d-inline-block float-right" @click="checkCartItemToCheckout()">
                      Solicitar Mídias
                    </base-button>
                  </div>
                </div>
	            <div class="d-table w-100" v-if="!Object.keys(groupedSacolaTitulos).length">
	            	<p class="lead text-center">Sua Sacola de Títulos está vazia.</p>
	            </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { SlideYUpTransition } from "vue2-transitions";

export default {
  name: 'cart',
  components: {
  	SlideYUpTransition
  },
  computed: {
    ...mapGetters('cart', [
        'sacolaTitulos',
        'sacolaTitulosAgrupada',
        'sacolaTitulosAgrupadaGold',
      ]),
    groupedSacolaTitulos() {
      return Object.assign({}, this.sacolaTitulosAgrupada, this.sacolaTitulosAgrupadaGold)
    }
  },
  data() {
    return {
      selected: [],
      allSelected: false,
    }
  },
  methods: {
  	...mapActions('cart', [
      'removeMedia',
      'checkCartItemToCheckout',
    ]),
    episodioFormat(episodio) {
      let episodioString = '';
      if ( episodio.temporada ) {
        episodioString += episodio.temporada+'x';
      }
      if ( episodio.episodio ) {
        episodioString += episodio.episodio+' - ';
      }
      episodioString += episodio.titulo_traduzido+ ' ('+episodio.ano+')';
      episodioString += ' - '+ episodio.duracao +'min';
      return episodioString;
    },
    toggleAll(checked) {
      this.selected = checked ? this.sacolaTitulos.slice() : []
    },
    isSeriado(titulo) {
      let check = titulo.filter(midia => midia.temporada !== null);
      return check.length || false;
    }
  },
};
</script>
<style lang="scss" scoped>
  div.episodios {
    font-size: 0.8em;
    p {
      display: block;
      clear: both;
      margin-bottom: 5px;
    }

  }
  .cart-table {
    thead {
      th {
        border-bottom: 0;
        font-size: 0.8em;
        vertical-align: middle;
        &.format {
          width: 15%;
        }
        &.titleName {
          font-size: 1.1em;
        }
      }
    }
    tbody {
      td {
        p {
          font-size: 0.9em;
          margin-bottom: 0;
          strong {
            font-weight: 700;
          }
          &.trecho {
            font-size: 0.75em;
            line-height: 1;
          }
        }
      }
    }
  }
</style>
